import script from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestPopupVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"

import "./PrestPopupVariantPierreVacance.vue?vue&type=style&index=0&id=8c7d9e92&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7d9e92"]])

export default __exports__